import React, { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/pages/ExplorePage.css';
import GoogleMap from '../components/map_interaction/GoogleMap';
import SuggestionsContext from '../components/explore_page/SuggestionsContext';
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from '@mui/material';
import ChatBot from '../components/ChatBot/ChatBot';
import ProfileTravelPreferences from '../components/profile/ProfileTravelPreferences';
import Popup from '../components/common/popup/Popup';

const ExplorePage = () => {
  const worldLocation = { lat: 20, lng: 1 };
  const defaultZoom = 2.5;
  const { suggestions } = useContext(SuggestionsContext);
  const isBreakpoint = useMediaQuery('(max-width:1024px)');
  const [isMapVisible, setIsMapVisible] = useState(!isBreakpoint);
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);

  const toggleMapVisibility = () => {
    setIsMapVisible(prev => !prev);
  };

  useEffect(() => {
    setIsMapVisible(!isBreakpoint);
  }, [isBreakpoint]);

  return (
    <div className="explore-page">
      <Helmet>
        <title>Explore - WeiFinders</title>
        <meta
          name="description"
          content="Explore travel suggestions, interactive maps, and personalized travel experiences on WeiFinders."
        />
        <meta property="og:title" content="Explore - WeiFinders" />
        <meta
          property="og:description"
          content="Explore travel suggestions, interactive maps, and personalized travel experiences on WeiFinders."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://weifinders.com/explore/ai-agent" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@WeiFinders" />
        <meta name="twitter:title" content="Explore - WeiFinders" />
        <meta
          name="twitter:description"
          content="Explore travel suggestions, interactive maps, and personalized travel experiences on WeiFinders."
        />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Explore - WeiFinders",
            "url": "https://weifinders.com/explore/ai-agent",
            "description": "Explore travel suggestions, interactive maps, and personalized travel experiences on WeiFinders."
          }
        `}</script>
      </Helmet>
      <main role="main" aria-label="Explore Page">
        <div className="explore-page__container">
          <div className="explore-page__chatbot-container">
            <ChatBot
              onOpenPreferences={() => setShowPreferencesModal(true)}
              toggleMapVisibility={toggleMapVisibility}
              isMapVisible={isMapVisible}
              title="Travel Assistant"
              subscriptionRequirement="none"
            />
          </div>
          <div className={`explore-page__map-section ${isMapVisible ? 'visible' : 'hidden'}`}>
            {isBreakpoint && isMapVisible && (
              <button
                className="explore-page__map-close-button"
                onClick={toggleMapVisibility}
                aria-label="Close Map"
                title="Close Map"
              >
                <CloseIcon />
              </button>
            )}
            <div className="explore-page__map-wrapper">
              <GoogleMap
                location={worldLocation}
                suggestions={suggestions}
                initialZoom={defaultZoom}
                pageName="ExplorePage"
                enablePlaceClicks={false}
              />
            </div>
          </div>
        </div>
        {showPreferencesModal && (
          <Popup
            title="Travel Preferences"
            onCancel={() => setShowPreferencesModal(false)}
            className="profile-travel-preferences-popup"
          >
            <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              <ProfileTravelPreferences
                onClose={() => setShowPreferencesModal(false)}
                isMobile={isBreakpoint}
              />
            </div>
          </Popup>
        )}
      </main>
    </div>
  );
};

export default ExplorePage;
